export const AUTH_TOKEN = "jwtToken"
export const USER_INFO = "userInfo"
export const DARK_CLASS = "dark-theme"
export const LIGHT_CLASS = "light-theme"
export const GOLD_CLASS = "gold-theme"
